import React, { useEffect, useState } from "react";
import {
  Button,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useGridApiRef } from "@mui/x-data-grid";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import { ACCEPTANCE_STATUS } from "pages/TaskManagement/constants/task.constants";
import { message } from "constants/responses/message";
import { useGlobalContext } from "context/GlobalContext";
import { CommentModal } from "components/ModalForm/CommentModal";
import { statusUpdateTaskApi } from "API/apis/task/updateAcceptanceStatus";
import { confirmAction } from "utils/functions/confirmAction";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { completionStatusUpdateTaskApi } from "API/apis/task/completionStatusUpdateTask";
import { useTaskDashboardContext } from "../context";
import { IndicatorBox } from "components/DateTime/IndicatorBox";
import { useSelector } from "react-redux";
import { ModalForDoneStatusProductTask } from "components/ModalForm/ModalForDoneStatusProductTask";
import { IO_FOR_PRODUCT_EXECUTION_TIMELINE } from "constants/taskConstants";
import { outputDoneTaskStatusApi } from "API/apis/dashboard/outputDoneTaskStatus";
import { TaskInfoCompact } from "./TaskInfoCompact";
import { DataGridWithHighlightClass } from "components/DataGrid/DataGridWithHighlightClass";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { bulkCompletionStatusUpdateTask } from "API/apis/task/bulkCompletionStatusUpdateTask";
import { FilterSortTableDashboard } from "components/FilterSortTable/FilterSortTableDashboard";

const allowedFilters = [
  { key: "docCode", value: "Code" },
  { key: "taskDetails", value: "Task Details" },
  { key: "docDetails", value: "Document Detail" },
  { key: "taskDescription", value: "Description" },
  { key: "taskByName", value: "Task By" },
  { key: "taskToName", value: "Task To" },
  { key: "deadline", value: "Deadline" },
  { key: "acceptanceStatus", value: "Acceptance Status" },
  { key: "acceptanceOn", value: "Acceptance Date" },
  { key: "doneStatus", value: "Done Status" },
  { key: "doneOn", value: "Done Date" },
  { key: "acknowledgeStatus", value: "Acknowledgement Status" },
  { key: "acknowledgeOn", value: "Acknowledgement Date" },
  { key: "isARequest", value: "Is Delegated task" },
];
export const TaskListForDashboard = ({ pageName, type }) => {
  const apiRef = useGridApiRef();

  const {
    assignedByMeAcceptedRecord,
    assignedByMeAcceptedRecordCount,
    assignedByMePendingRecord,
    assignedByMePendingRecordCount,
    assignedToMeAcceptedRecord,
    assignedToMeAcceptedRecordCount,
    assignedToMePendingRecord,
    assignedToMePendingRecordCount,
    setReloadRequired,
  } = useTaskDashboardContext();
  const currentUserId = useSelector((state) => state.user.state.userId);

  let records = [];
  let recordCount = 0;
  let actionDropDownForAssignedToMeList = [];
  let requiredBulkUpdate = false;
  switch (type) {
    case "assignedByMeAccepted":
      records = assignedByMeAcceptedRecord;
      recordCount = assignedByMeAcceptedRecordCount;
      actionDropDownForAssignedToMeList = ["ACKNOWLEDGE"];
      requiredBulkUpdate = true;
      break;
    case "assignedByMePending":
      records = assignedByMePendingRecord;
      recordCount = assignedByMePendingRecordCount;
      actionDropDownForAssignedToMeList = ["APPROVE"];
      requiredBulkUpdate = true;
      break;
    case "assignedToMeAccepted":
      records = assignedToMeAcceptedRecord;
      recordCount = assignedToMeAcceptedRecordCount;
      actionDropDownForAssignedToMeList = ["DONE", "ACKNOWLEDGE"];
      break;
    case "assignedToMePending":
      records = assignedToMePendingRecord;
      recordCount = assignedToMePendingRecordCount;
      actionDropDownForAssignedToMeList = ["ACCEPTED", "REJECTED"];
      requiredBulkUpdate = true;
      break;
  }
  const [sortedRecords, setSortedRecords] = useState(records);

  const [openModal, setOpenModal] = useState(false);
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const [selectedRow, setSelectedRow] = useState(null);
  const [anchorElBulk, setAnchorElBulk] = useState(null);
  const openBulk = Boolean(anchorElBulk);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedTaskId, setSelectedTaskId] = useState(0);
  const [acceptanceStatusComment, setAcceptanceStatusComment] = useState("");
  const [doneStatusOutputModal, setDoneStatusOutputModal] = useState(false);
  const [timelineItem, setTimelineItem] = useState("");
  const [doneOutput, setDoneOutput] = useState([]);
  const [actionDropDownForAssignedToMe, setActionDropDownForAssignedToMe] =
    useState([...actionDropDownForAssignedToMeList]);

  const handleClick = (event, id, rowData) => {
    setSelectedTaskId(id);
    setSelectedRow(rowData);
    setAnchorEl(event.currentTarget);
  };

  const propsForDataGrid = requiredBulkUpdate && {
    checkboxSelection: true,
    selectionModel: selectedRows,
    onRowSelectionModelChange: (newSelection) => setSelectedRows(newSelection),
  };

  useEffect(() => {
    apiRef.current.setRowSelectionModel([]);
  }, []);
  const handleDoneStatusOutputSubmit = async (e) => {
    e.preventDefault();
    const output = IO_FOR_PRODUCT_EXECUTION_TIMELINE[
      timelineItem
    ].outputItems.map((item, index) => {
      return { [item]: doneOutput[index] };
    });
    try {
      const { data: outputData, status: outputStatus } =
        await outputDoneTaskStatusApi({
          output,
          docId: selectedRow.docId,
          type: "OUTPUT",
          timelineItem,
        });
      if (outputStatus !== STATUS_CODES.SUCCESS) {
        throw new Error(message.error.generalFailure);
      }
      const { data, status } = await completionStatusUpdateTaskApi(
        selectedTaskId,
        "DONE"
      );
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setSuccess(data?.message);
    } catch (error) {
      setError(error.message);
    } finally {
      setDoneStatusOutputModal(false);
      setReloadRequired(true);
      setIsLoading(false);
    }
  };
  const handleClose = async (currentStatus) => {
    if (
      selectedRow?.subDocId === 1 &&
      currentStatus === "DONE" &&
      IO_FOR_PRODUCT_EXECUTION_TIMELINE[selectedRow.taskDetails]
        .isRequiredInDoneStatus
    ) {
      setDoneStatusOutputModal(true);
      setTimelineItem(selectedRow.taskDetails);
    } else {
      try {
        if (Object.keys(ACCEPTANCE_STATUS).includes(currentStatus)) {
          setSelectedStatus(currentStatus);
          setOpenModal(true);
        } else {
          try {
            const confirmed = confirmAction(
              message.info.generalConfirmBoxMessage
            );
            if (!confirmed) {
              setAnchorEl(null);
              return;
            }
            setIsLoading(true);
            const { data, status } = await completionStatusUpdateTaskApi(
              selectedTaskId,
              currentStatus
            );
            if (status !== STATUS_CODES.SUCCESS) {
              throw new Error(data.message);
            }
            setSuccess(data?.message);
          } catch (error) {
            setError(error.message);
          } finally {
            setReloadRequired(true);
            setIsLoading(false);
          }
        }
      } catch (error) {
        setError(error.message);
      }
    }
    setAnchorEl(null);
  };

  const taskListColumns = [
    {
      field: "deadline",
      headerName: "Task Details",
      flex: 1,
      sortable: false,
      renderHeader: (params) => (
        <FlexBox justifyContent="" alignItems="center">
          <FlexBox alignItems="center">
            <FilterSortTableDashboard
              records={records}
              setOutputRecords={setSortedRecords}
              allowedFilters={allowedFilters}
            />
            <Typography>{pageName}</Typography>
          </FlexBox>
          {type !== "assignedToMeAccepted" && (
            <>
              <Button
                variant="outlined"
                size="small"
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => handleBulkClick(e)}
                sx={{ paddingY: 0, marginLeft: 5 }}
              >
                Bulk Update
              </Button>
              <Menu
                anchorEl={anchorElBulk}
                open={openBulk}
                onClose={() => setAnchorElBulk(null)}
              >
                {actionDropDownForAssignedToMe.map((item) => (
                  <MenuItem key={item} onClick={() => handleBulkUpdate(item)}>
                    <ListItemText primary={item} />
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
        </FlexBox>
      ),
      renderCell: (params) => (
        <IndicatorBox
          targetDate={params.row.deadline}
          alertBeforeDays={params.row.alertBeforeDays}
          key={params.row.id}
        >
          <TaskInfoCompact
            heading={params.row.docCode}
            taskName={params.row.taskDetails}
            docDetails={params.row.docDetails}
            description={params.row.taskDescription}
            comment={params.row.acceptanceComment}
            assignedBy={
              type !== "assignedByMeAccepted" &&
              type !== "assignedByMePending" &&
              params.row.taskByName
            }
            assignedTo={
              type !== "assignedToMeAccepted" &&
              type !== "assignedToMePending" &&
              params.row.taskToName
            }
            assignedOn={params.row.taskToOn}
            acceptanceStatus={params.row.acceptanceStatus}
            acceptanceOn={params.row.acceptanceOn}
            deadline={params.row.deadline}
            doneStatus={params.row.doneStatus}
            doneOn={params.row.doneOn}
            records={records}
            recordCount={recordCount}
            actionDropDownForAssignedToMe={actionDropDownForAssignedToMe}
            fullRowData={params.row}
            handleClick={handleClick}
            taskId={params.row.id}
            acknowledgeStatus={params.row.acknowledgeStatus}
            acknowledge={params.row.acknowledgeOn}
            isARequest={params.row.isARequest}
          />
        </IndicatorBox>
      ),
    },
  ];
  const handleBulkClick = (event) => {
    if (selectedRows.length <= 0) {
      alert("No task selected!");
      return;
    }
    setAnchorElBulk(event.currentTarget);
  };

  const handleBulkUpdate = async (currentStatus) => {
    setSelectedStatus(currentStatus);
    if (currentStatus === "ACCEPTED" || currentStatus === "REJECTED") {
      setOpenModal(true);
    } else {
      const confirmed = confirmAction(message.info.generalConfirmBoxMessage);
      if (!confirmed) {
        setAnchorElBulk(null);
        return;
      }
      try {
        setIsLoading(true);
        const { data, status } = await bulkCompletionStatusUpdateTask({
          ids: selectedRows,
          status: currentStatus,
        });
        if (status !== STATUS_CODES.SUCCESS) {
          throw new Error(data.message);
        }
        setSuccess(data?.message);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
        setAnchorElBulk(null);
        setReloadRequired(true);
      }
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    try {
      setOpenModal(false);
      setIsLoading(true);
      const { data, status } = await statusUpdateTaskApi({
        acceptanceStatus: selectedStatus,
        acceptanceStatusComment: acceptanceStatusComment,
        ids: selectedRows.length ? selectedRows : [selectedTaskId],
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setAcceptanceStatusComment("");
      setSuccess(data?.message);
    } catch (error) {
      setError(error.message);
    } finally {
      setReloadRequired(true);
      setAnchorEl(null);
      setSelectedTaskId(0);
      setIsLoading(false);
    }
  };
  return (
    <>
      <ModalForDoneStatusProductTask
        setOpenDoneStatusModal={setDoneStatusOutputModal}
        openDoneStatusModal={doneStatusOutputModal}
        handleDoneStatusOutputSubmit={handleDoneStatusOutputSubmit}
        timelineItem={timelineItem}
        doneOutput={doneOutput}
        setDoneOutput={setDoneOutput}
      />
      <CommentModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        formDescription={message.info.acceptanceStatusComment}
        comment={acceptanceStatusComment}
        setComment={setAcceptanceStatusComment}
        handleCommentSubmit={handleCommentSubmit}
      />
      <ToolbarThinWrapper />
      <div style={{ width: "100%" }}>
        <DataGridWithHighlightClass
          apiRef={apiRef}
          rows={sortedRecords}
          getRowHeight={() => "auto"}
          disableRowSelectionOnClick
          columns={taskListColumns}
          {...propsForDataGrid}
          disableColumnMenu={true}
          columnVisibilityModel={{
            id: false,
          }}
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {actionDropDownForAssignedToMe.map((item, index) => {
            return (
              <MenuItem
                key={"menuItem" + index}
                onClick={() => handleClose(item)}
                disabled={
                  ((item === "ACCEPTED" || item === "REJECTED") &&
                    (selectedRow?.isARequest || false)) ||
                  (item === "APPROVE" && (!selectedRow?.isARequest || false)) ||
                  (item === "ACKNOWLEDGE" &&
                    (!selectedRow?.doneStatus ||
                      currentUserId !== selectedRow?.taskBy ||
                      false)) ||
                  (item === "DONE" && (selectedRow?.doneStatus || false))
                }
              >
                {item}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    </>
  );
};
